export default __webpack_public_path__ + "1e5d6df57206a2c8031dff42a09517d6.gif";